let dialog = null;
let queue = Promise.resolve();

function connectedDialog() {
  if (dialog?.isConnected) {
    return dialog;
  }

  const title = document.createElement("span");

  title.slot = "title";
  dialog = document.createElement("sp-confirm");
  dialog.setAttribute("cancelable", "");
  dialog.setAttribute("cancel-on-escape", "");
  dialog.setAttribute("open", "false");
  dialog.append(title);
  document.body.append(dialog);

  return dialog;
}

function ask({ title, content, confirmLabel, cancelLabel }) {
  const element = connectedDialog();

  element.querySelector('[slot="title"]').textContent = title;
  element.setAttribute("label", title);
  element.setAttribute("content", content);
  element.setAttribute("confirm-label", confirmLabel);
  element.setAttribute("cancel-label", cancelLabel);

  return new Promise(function waitForDecision(resolve) {
    function decide(event) {
      element.removeEventListener("confirm", decide);
      element.removeEventListener("cancel", decide);
      element.setAttribute("open", "false");
      resolve(event.type === "confirm");
    }

    element.addEventListener("confirm", decide);
    element.addEventListener("cancel", decide);
    element.setAttribute("open", "true");
  });
}

/**
 * Asks a yes/no question in the page's one shared `sp-confirm` and resolves the answer. Escape
 * answers no. Questions asked while another is open wait their turn.
 *
 * @param {Object} question
 * @param {String} question.title - Dialog heading.
 * @param {String} question.content - The question.
 * @param {String} question.confirmLabel - Label of the button that resolves `true`.
 * @param {String} question.cancelLabel - Label of the button that resolves `false`.
 * @returns {Promise<Boolean>} `true` when the user confirms, `false` when they cancel.
 */
export function requestConfirmation(question) {
  const answer = queue.then(() => ask(question));

  queue = answer;

  return answer;
}
